<ng-container *ngxPermissionsOnly="permissions.CAN_ADD_MODEL">
  <button
    nbButton
    size="tiny"
    status="primary"
    [routerLink]="['/', companyId, 'models', 'add']"
    class="sites-nav__button"
  >
    <nb-icon icon="plus-square-outline"></nb-icon>
    Add model
  </button>
</ng-container>
<ng-container *ngxPermissionsOnly="permissions.CAN_UPLOAD_PHOTOS">
  <button
    nbButton
    size="tiny"
    status="primary"
    class="sites-nav__button"
    [routerLink]="['/', companyId, 'uploader', 'selection']"
  >
    <nb-icon icon="camera-outline"></nb-icon>
    Upload photos
  </button>
</ng-container>
